module.exports = __webpack_public_path__ + "38f6a7b0a9330b2c9682afcb60480db4.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/goldencity2.jpg
// module id = 899
// module chunks = 0